export const UMB_COLLECTION_ITEM_PICKER_MODAL_ALIAS = 'Umb.Modal.CollectionItemPicker';
